import { render, staticRenderFns } from "./Result.html?vue&type=template&id=024352f0&scoped=true&"
import script from "./Result.ts?vue&type=script&lang=ts&"
export * from "./Result.ts?vue&type=script&lang=ts&"
import style0 from "./Result.css?vue&type=style&index=0&id=024352f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024352f0",
  null
  
)

export default component.exports